"use strict";

exports.__esModule = true;
exports.ColumnHeader = ColumnHeader;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _FilterPopover = require("../../Filters/FilterPopover");
var _FilterSearch = require("./FilterSearch");
var _FilterFromList = require("./FilterFromList");
var _HeaderIcons = require("./HeaderIcons");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ColumnHeader(props) {
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var translate = translator.translate;
  var accessor = props.accessor,
    icon = props.icon,
    header = props.header,
    titleOverridden = props.titleOverridden,
    sorted = props.sorted,
    filtered = props.filtered,
    canFilter = props.canFilter,
    canSort = props.canSort,
    canSearch = props.canSearch,
    exactMatch = props.exactMatch,
    setSorted = props.setSorted;
  var isExactMatch = exactMatch !== false;
  var validYear = new Date(header, 0, 1) instanceof Date && !isNaN(new Date(header, 0, 1));
  var yearLabel = translate("DataTable.Column.Title.year", "Year");
  // A title set in the widget editor wins over the catalog: passed as
  // react-intl's defaultMessage it would lose to any DataTable.Column.Title.*.
  var defaultColumnHeader = titleOverridden ? "" + header : translate("DataTable.Column.Title." + accessor, "" + header);
  var sortedTuple = sorted.find(function (sort) {
    return sort.id === accessor;
  });
  var sortOrder = sortedTuple ? sortedTuple.desc : undefined;
  var filteredTuple = filtered.find(function (filter) {
    return filter.id === accessor;
  });
  return /*#__PURE__*/_react["default"].createElement(_FilterPopover.FilterPopover, {
    key: accessor,
    position: _core.Position.BOTTOM,
    popoverTarget: /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
      }
    }, icon ? icon : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, validYear ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-header"
    }, validYear ? yearLabel + " " + header.toString() : yearLabel) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "column-header"
    }, defaultColumnHeader)), /*#__PURE__*/_react["default"].createElement("div", null, canSort ? /*#__PURE__*/_react["default"].createElement(_HeaderIcons.SortIcon, {
      desc: sortOrder,
      canSort: canSort
    }) : null, canSort || canFilter || canSearch ? /*#__PURE__*/_react["default"].createElement(_HeaderIcons.FilterIcon, {
      isFiltered: !!(filteredTuple && filteredTuple.value && filteredTuple.value.length > 0),
      canSort: !!canSort,
      canFilter: !!canFilter
    }) : null)),
    popoverContent: canSort || canFilter ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Menu, {
      key: accessor + "-sortMenu"
    }, canSort ? /*#__PURE__*/_react["default"].createElement(_HeaderIcons.SortOption, {
      accessor: accessor,
      sorted: sorted,
      setSorted: setSorted
    }) : null), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, canFilter && isExactMatch ? /*#__PURE__*/_react["default"].createElement(_FilterFromList.FilterFromList, props) : null), /*#__PURE__*/_react["default"].createElement(_core.Menu, {
      key: accessor + "-filterSearchMenu"
    }, canFilter && !isExactMatch ? /*#__PURE__*/_react["default"].createElement(_FilterSearch.FilterSearch, props) : null, canSearch && !canFilter ? /*#__PURE__*/_react["default"].createElement(_FilterSearch.FilterSearch, props) : null)) : null,
    usePortal: true
  });
}